import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { forkJoin, Observable, Subject } from "rxjs";
import { environment } from "environments/environment";
import { IArticulo, IArticuloFull } from "../models/articulo";
import { IUser } from "@core/models/auth/user";
import { AuthLocalService } from "@core/auth/auth-local.service";

@Injectable()
export class ArticulosService {
  private user: IUser;
  static SIN_ESTADO = "Sin Estado";
  static PREETIQUETADO = "Preetiquetado";
  static ETIQUETADO = "Etiquetado";
  static INVENTARIADO = "Inventariado";
  private newToken: string;

  constructor(private http: HttpClient, private _authLocal: AuthLocalService) {
    this.user = this._authLocal.getCurrentUser();
  }

  getMarcas(filter): Observable<any> {
    var subject = new Subject<any>();
    this.http.get<any>(environment.api.materiales.articulos.marcas + filter)
      .subscribe((resp: any) => {
        this.newToken = resp.token;
        this._authLocal.updateToken(this.newToken)
        subject.next(resp.result); // Emitimos el objeto directamente
        subject.complete(); // Cerramos el Subject
      });
    return subject.asObservable();
  }

  newMarca(marca) {
    var subject = new Subject<any>();
    this.http.post(environment.api.materiales.articulos.marcas, { Descripcion: marca })
      .subscribe((resp: any) => {
        this.newToken = resp.token;
        this._authLocal.updateToken(this.newToken)
        subject.next(resp.result); // Emitimos el objeto directamente
        subject.complete(); // Cerramos el Subject
      });
    return subject.asObservable();
  }

  getArticulos(filter: any): Observable<IArticulo[]> {
    const subject = new Subject<any>();
    this.http.get<IArticulo[]>(environment.api.materiales.articulos.view_articulos + filter, { observe: "response" })
      .subscribe((resp: any) => {
        this.newToken = resp.body.token;
        this._authLocal.updateToken(this.newToken)
        subject.next({
          list: resp.body.result,
          totalPages: resp.headers.get("x-pagination-page-count"),
          totalCount: resp.headers.get("x-pagination-total-count"),
        });
      });
    return subject.asObservable();
  }

  getArticulosRelacionados(codigo): Observable<any> {
    const subject = new Subject<any>();
    this.http.get(environment.api.materiales.articulos.articulos + "/" + codigo + "?expand=asociados").subscribe(
      (resp: any) => {
        this.newToken = resp.token; // Guardamos el token recibido
        this._authLocal.updateToken(this.newToken); // Actualizamos el token
        subject.next(resp.result); // Emitimos el objeto directamente
        subject.complete(); // Cerramos el Subject
      }
    );
    return subject.asObservable(); // Retornamos el Observable

  }

  getArticulosFull(filtro?: any): Observable<IArticulo[]> {
    const subject = new Subject<IArticulo[]>();
    this.http.get<any[]>(environment.api.materiales.articulos.articulos + (filtro ? filtro : "")).subscribe(
      (resp: any) => {
        this.newToken = resp.token; // Guardamos el token recibido
        this._authLocal.updateToken(this.newToken); // Actualizamos el token
        subject.next(resp.result); // Emitimos el objeto directamente
        subject.complete(); // Cerramos el Subject
      }
    );
    return subject.asObservable(); // Retornamos el Observable

  }

  unificarArticulo(payload: any): Observable<any> {
    const subject = new Subject<any>();
    this.http.post(environment.api.materiales.articulos.unificar, payload).subscribe(
      (resp: any) => {
        this.newToken = resp.token; // Guardamos el token recibido
        this._authLocal.updateToken(this.newToken); // Actualizamos el token
        subject.next(resp.result); // Emitimos el objeto directamente
        subject.complete(); // Cerramos el Subject
      }
    );
    return subject.asObservable(); // Retornamos el Observable

  }

  getArticulosContadores(filtro: any): Observable<any[]> {
    const subject = new Subject<any[]>();
    this.http.get<any[]>(environment.api.materiales.articulos.contadores + (filtro ? filtro : "")).subscribe(
      (resp: any) => {
        this.newToken = resp.token; // Guardamos el token recibido
        this._authLocal.updateToken(this.newToken); // Actualizamos el token
        subject.next(resp.result); // Emitimos el objeto directamente
        subject.complete(); // Cerramos el Subject
      }
    );
    return subject.asObservable(); // Retornamos el Observable

  }

  getArticulosContador(estado: string): Observable<any[]> {
    const subject = new Subject<any[]>();
    this.http.get<any[]>(environment.api.materiales.articulos.contador + "?estado=" + estado).subscribe(
      (resp: any) => {
        this.newToken = resp.token; // Guardamos el token recibido
        this._authLocal.updateToken(this.newToken); // Actualizamos el token
        subject.next(resp.result); // Emitimos el objeto directamente
        subject.complete(); // Cerramos el Subject
      }
    );
    return subject.asObservable(); // Retornamos el Observable

  }

  getViewArticuloStockPanols(filtro?: string): Observable<IArticulo> {
    const subject = new Subject<IArticulo>();
    let url = environment.api.materiales.articulos.viewArticuloStockPanols + filtro;
    this.http.get<any>(url).subscribe(
      (resp: any) => {
        this.newToken = resp.token; // Guardamos el token recibido
        this._authLocal.updateToken(this.newToken); // Actualizamos el token
        subject.next(resp.result); // Emitimos el objeto directamente
        subject.complete(); // Cerramos el Subject
      }
    );
    return subject.asObservable(); // Retornamos el Observable

  }

  getViewArticuloMovimientoStocks(filtro?: any): Observable<any> {
    const subject = new Subject<any>();
    this.http.get<any>(environment.api.materiales.articulos.viewArticuloMovimientoStocks + (filtro ? filtro : "")).subscribe(
      (resp: any) => {
        this.newToken = resp.token; // Guardamos el token recibido
        this._authLocal.updateToken(this.newToken); // Actualizamos el token
        subject.next(resp.result); // Emitimos el objeto directamente
        subject.complete(); // Cerramos el Subject
      }
    );
    return subject.asObservable(); // Retornamos el Observable

  }

  getArticulo(id: any): Observable<IArticulo> {
    const subject = new Subject<IArticulo>();
    this.http.get<any>(environment.api.materiales.articulos.articulos + `/${id}`).subscribe(
      (resp: any) => {
        this.newToken = resp.token; // Guardamos el token recibido
        this._authLocal.updateToken(this.newToken); // Actualizamos el token
        subject.next(resp.result); // Emitimos el objeto directamente
        subject.complete(); // Cerramos el Subject
      }
    );
    return subject.asObservable(); // Retornamos el Observable
  }

  eliminarArticulo(id: any): Observable<IArticulo> {
    return this.http.delete<any>(environment.api.materiales.articulos.articulos + `/${id}`);
  }

  getRubros(filtro?: any): Observable<any[]> {
    const subject = new Subject<any[]>();
    this.http.get<any[]>(environment.api.materiales.articulos.rubros + (filtro ? filtro : "")).subscribe(
      (resp: any) => {
        this.newToken = resp.token; // Guardamos el token recibido
        this._authLocal.updateToken(this.newToken); // Actualizamos el token
        subject.next(resp.result); // Emitimos el objeto directamente
        subject.complete(); // Cerramos el Subject
      }
    );
    return subject.asObservable(); // Retornamos el Observable

  }

  getSectores(filtro?: any): Observable<any[]> {
    const subject = new Subject<any[]>();
    this.http.get<any[]>(environment.api.materiales.articulos.sectores + (filtro ? filtro : "")).subscribe(
      (resp: any) => {
        this.newToken = resp.token; // Guardamos el token recibido
        this._authLocal.updateToken(this.newToken); // Actualizamos el token
        subject.next(resp.result); // Emitimos el objeto directamente
        subject.complete(); // Cerramos el Subject
      }
    );
    return subject.asObservable(); // Retornamos el Observable

  }

  getSubSectores(filtro?: any): Observable<any[]> {
    const subject = new Subject<any[]>();
    this.http.get<any[]>(environment.api.materiales.articulos.subsectores + (filtro ? filtro : "")).subscribe(
      (resp: any) => {
        this.newToken = resp.token; // Guardamos el token recibido
        this._authLocal.updateToken(this.newToken); // Actualizamos el token
        subject.next(resp.result); // Emitimos el objeto directamente
        subject.complete(); // Cerramos el Subject
      }
    );
    return subject.asObservable(); // Retornamos el Observable

  }

  getProveedores(): Observable<any[]> {
    const subject = new Subject<any[]>();
    this.http.get<any[]>(environment.api.materiales.articulos.proveedores).subscribe(
      (resp: any) => {
        this.newToken = resp.token; // Guardamos el token recibido
        this._authLocal.updateToken(this.newToken); // Actualizamos el token
        subject.next(resp.result); // Emitimos el objeto directamente
        subject.complete(); // Cerramos el Subject
      }
    );
    return subject.asObservable(); // Retornamos el Observable
  }

  getUnidadMedidas(): Observable<any[]> {
    const subject = new Subject<any[]>();
    this.http.get<any[]>(environment.api.materiales.articulos.unidadMedida).subscribe(
      (resp: any) => {
        this.newToken = resp.token; // Guardamos el token recibido
        this._authLocal.updateToken(this.newToken); // Actualizamos el token
        subject.next(resp.result); // Emitimos el objeto directamente
        subject.complete(); // Cerramos el Subject
      }
    );
    return subject.asObservable(); // Retornamos el Observable

  }

  getArtUnidadMedidas(filtro?: any): Observable<any[]> {
    const subject = new Subject<any[]>();
    this.http.get<any[]>(environment.api.materiales.articulos.artUnidadMedida + (filtro ? filtro : "")).subscribe(
      (resp: any) => {
        this.newToken = resp.token; // Guardamos el token recibido
        this._authLocal.updateToken(this.newToken); // Actualizamos el token
        subject.next(resp.result); // Emitimos el objeto directamente
        subject.complete(); // Cerramos el Subject
      }
    );
    return subject.asObservable(); // Retornamos el Observable
  }

  getViewArtUnidadMedidas(filtro?: any): Observable<any[]> {
    const subject = new Subject<any[]>();
    this.http.get<any[]>(environment.api.materiales.articulos.viewArtUnidadMedida + (filtro ? filtro : "")).subscribe(
      (resp: any) => {
        this.newToken = resp.token; // Guardamos el token recibido
        this._authLocal.updateToken(this.newToken); // Actualizamos el token
        subject.next(resp.result); // Emitimos el objeto directamente
        subject.complete(); // Cerramos el Subject
      }
    );
    return subject.asObservable(); // Retornamos el Observable
  }

  cambiarEquivalencia(datos?: any): Observable<any> {
    const subject = new Subject<any>();
    this.http.post(environment.api.materiales.articulos.cambiar_equivalencia, datos).subscribe(
      (resp: any) => {
        this.newToken = resp.token; // Guardamos el token recibido
        this._authLocal.updateToken(this.newToken); // Actualizamos el token
        subject.next(resp.result); // Emitimos el objeto directamente
        subject.complete(); // Cerramos el Subject
      }
    );
    return subject.asObservable(); // Retornamos el Observable
  }

  getArtProveedores(filtro?: any): Observable<any[]> {
    const subject = new Subject<any[]>();
    this.http.get<any[]>(environment.api.materiales.articulos.artProveedores + (filtro ? filtro : "")).subscribe(
      (resp: any) => {
        this.newToken = resp.token; // Guardamos el token recibido
        this._authLocal.updateToken(this.newToken); // Actualizamos el token
        subject.next(resp.result); // Emitimos el objeto directamente
        subject.complete(); // Cerramos el Subject
      }
    );
    return subject.asObservable(); // Retornamos el Observable
  }

  getImagen(filtro?: any): Observable<any> {
    const subject = new Subject<any>();
    this.http.get<any[]>(environment.api.materiales.articulos.imagenes + (filtro ? filtro : "")).subscribe(
      (resp: any) => {
        this.newToken = resp.token; // Guardamos el token recibido
        this._authLocal.updateToken(this.newToken); // Actualizamos el token
        subject.next(resp.result); // Emitimos el objeto directamente
        subject.complete(); // Cerramos el Subject
      }
    );
    return subject.asObservable(); // Retornamos el Observable
  }
  /**recibe por parámetro el artículo y el Codigo o id del artículo */
  editArticulo(articulo: any, idArticulo: any): Observable<any> {
    const subject = new Subject<any>();
    this.http.put(environment.api.materiales.articulos.articulos + `/${idArticulo}`, articulo).subscribe(
      (resp: any) => {
        this.newToken = resp.token; // Guardamos el token recibido
        this._authLocal.updateToken(this.newToken); // Actualizamos el token
        subject.next(resp.result); // Emitimos el objeto directamente
        subject.complete(); // Cerramos el Subject
      }
    );
    return subject.asObservable(); // Retornamos el Observable

  }

  createArticulo(articulo: any): Observable<any> {
    const subject = new Subject<any>();
    this.http.post(environment.api.materiales.articulos.articulos, articulo).subscribe(
      (resp: any) => {
        this.newToken = resp.token; // Guardamos el token recibido
        this._authLocal.updateToken(this.newToken); // Actualizamos el token
        subject.next(resp.result); // Emitimos el objeto directamente
        subject.complete(); // Cerramos el Subject
      }
    );
    return subject.asObservable(); // Retornamos el Observable

  }

  deleteArtUnidadMedida(unidad: any): Observable<any> {
    return this.http.delete(`${environment.api.materiales.articulos.artUnidadMedida}/${unidad.codigo}`);
  }

  deleteArtProveedor(proveedoresSelectedAux: any[]): Observable<any> {
    proveedoresSelectedAux.forEach(async (proveedor) => {
      await this.http.delete(`${environment.api.materiales.articulos.artProveedores}/${proveedor.Codigo}`);
    });
    return;
  }

  createArtProveedor(prov: any): Observable<any> {
    const subject = new Subject<any>();
    this.http.post(environment.api.materiales.articulos.artProveedores, prov).subscribe(
      (resp: any) => {
        this.newToken = resp.token; // Guardamos el token recibido
        this._authLocal.updateToken(this.newToken); // Actualizamos el token
        subject.next(resp.result); // Emitimos el objeto directamente
        subject.complete(); // Cerramos el Subject
      }
    );
    return subject.asObservable(); // Retornamos el Observable

  }

  createArtUnidadMedida(artUM: any): Observable<any> {
    const subject = new Subject<any>();
    this.http.post(environment.api.materiales.articulos.artUnidadMedida, artUM).subscribe(
      (resp: any) => {
        this.newToken = resp.token; // Guardamos el token recibido
        this._authLocal.updateToken(this.newToken); // Actualizamos el token
        subject.next(resp.result); // Emitimos el objeto directamente
        subject.complete(); // Cerramos el Subject
      }
    );
    return subject.asObservable(); // Retornamos el Observable

  }

  getMovimientos(filtro: string): Observable<any> {
    let formData = new FormData();
    formData.append("auditoria", this.user.nick);
    formData.append("usuario_auditoria", this.user.codigo.toString());
    formData.append("servicio", "get_stock_movimiento");
    formData.append("filtro", filtro);
    return this.http.post(environment.controlador, formData);
  }

  getMovimientosGrafico(id: any): Observable<any> {
    const subject = new Subject<any>();
    this.http.get(`${environment.api.materiales.articulos.movimientosGrafico}?filter[articulo]=${id}`).subscribe(
      (resp: any) => {
        this.newToken = resp.token; // Guardamos el token recibido
        this._authLocal.updateToken(this.newToken); // Actualizamos el token
        subject.next(resp.result); // Emitimos el objeto directamente
        subject.complete(); // Cerramos el Subject
      }
    );
    return subject.asObservable(); // Retornamos el Observable
  }

  createRubro(rubro: any): Observable<any> {
    const subject = new Subject<any>();
    this.http.post(environment.api.materiales.articulos.rubros, rubro).subscribe(
      (resp: any) => {
        this.newToken = resp.token; // Guardamos el token recibido
        this._authLocal.updateToken(this.newToken); // Actualizamos el token
        subject.next(resp.result); // Emitimos el objeto directamente
        subject.complete(); // Cerramos el Subject
      }
    );
    return subject.asObservable(); // Retornamos el Observable
  }

  createSector(sector: any): Observable<any> {
    const subject = new Subject<any>();
    this.http.post(environment.api.materiales.articulos.sectores, sector).subscribe(
      (resp: any) => {
        this.newToken = resp.token; // Guardamos el token recibido
        this._authLocal.updateToken(this.newToken); // Actualizamos el token
        subject.next(resp.result); // Emitimos el objeto directamente
        subject.complete(); // Cerramos el Subject
      }
    );
    return subject.asObservable(); // Retornamos el Observable
  }

  createSubsector(subsector: any): Observable<any> {
    const subject = new Subject<any>();
    this.http.post(environment.api.materiales.articulos.subsectores, subsector).subscribe(
      (resp: any) => {
        this.newToken = resp.token; // Guardamos el token recibido
        this._authLocal.updateToken(this.newToken); // Actualizamos el token
        subject.next(resp.result); // Emitimos el objeto directamente
        subject.complete(); // Cerramos el Subject
      }
    );
    return subject.asObservable(); // Retornamos el Observable
  }
}
